import { gql } from 'graphql-request'
import { loginServiceGraphql, merchantServiceGraphql } from '../config/Config';

export const getCountry = async(merchantId) => {
  const COUNTRY = gql`
  query Merchant($merchantId: Int!) {
    Merchant(id: $merchantId) {
      country
    }
  }
  `
  const response = await merchantServiceGraphql.request(COUNTRY, { merchantId })
  return response.Merchant
}

export const allStates = async(countryID) => {
    const STATES = gql`
        query AllStates($filter: StateFilter) {
            allStates(filter: $filter) {
              id
              name
              countryID
              created_at
              apollo_reference_city {
                id
                name
                stateID
                created_at
              }
            }
          }
    `;
    const respone = await loginServiceGraphql.request(STATES, { filter: { countryID: countryID } })
    return respone.allStates;
}

export const allCities = async (stateID) => {
  const CITIES = gql`
    query AllCities($filter: CityFilter) {
      allCities(filter: $filter) {
        id
        name
      }
    }
  `
  const respone = await loginServiceGraphql.request(CITIES, { filter: { stateID: stateID } })
  return respone.allCities;
}

export const allCountries = async() => {
  const COUNTRIES = gql`
  query AllCountries {
    allCountries {
      id
      name
      continent
    }
  }
  `

  const response = await loginServiceGraphql.request(COUNTRIES);
  return response.allCountries;
}